import(/* webpackMode: "eager", webpackExports: ["DatadogInit"] */ "/app/apps/nsight-web/src/app/datadog-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserflowInit"] */ "/app/apps/nsight-web/src/app/userflow-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/apps/nsight-web/src/providers/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/app/apps/nsight-web/src/providers/client-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCReactProvider"] */ "/app/apps/nsight-web/src/trpc/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-nunito\"}],\"variableName\":\"nunito\"}");
;
import(/* webpackMode: "eager" */ "/app/tooling/tailwind-config/styles.css");
